import styled from 'styled-components';

export const Wrapper = styled.div`
  max-width: 320px;
  padding: 32px 24px;

  @media (min-width: 768px) {
    max-width: 480px;
    padding: 48px 48px;
  }
`;

export const Text = styled.p`
  font-family: ${props => props.theme.fonts.body};
  font-size: 14px;
  line-height: 1.5;
  text-align: center;
  color: ${props => props.theme.colors.textPrimary};

  @media (min-width: 768px) {
    font-size: 17px;
  }
`;

export const StyledForm = styled.form`
  display: flex;
  flex-direction: column;
  width: 100%;
  gap: 16px;
  align-items: center;
  margin-top: 24px;

  @media (min-width: 768px) {
    gap: 24px;
    margin-top: 32px;
  }
`;

export const Btn = styled.button`
  padding: 14px 32px;
  border: none;
  border-radius: ${props => props.theme.radii.pill};
  font-family: ${props => props.theme.fonts.body};
  font-weight: 600;
  font-size: 14px;
  color: ${props => props.theme.colors.textPrimary};
  background: ${props => props.theme.colors.secondary};
  cursor: pointer;
  transition: ${props => props.theme.transition.main};

  &:hover,
  &:focus-visible {
    background: ${props => props.theme.colors.hoverColor};
  }

  @media (min-width: 768px) {
    padding: 16px 44px;
    font-size: 16px;
  }
`;
